import styled from 'styled-components';

export const FieldLabel = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.85rem;
  color: #555;
  display: block;
  margin-bottom: 0.4rem;
`;

export const FieldRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  position: relative;
`;

export const FieldError = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.78rem;
  color: #ff2e3e;
  position: absolute;
  right: 0;
  top: 0;
`;

export const ArenaCard = styled.div`
  border: 1px solid #d0e8ff;
  border-radius: 0.6rem;
  padding: 1rem;
  background: #f7fbff;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const TagsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #fff;
  border: 1px solid #d0e8ff;
  border-radius: 2rem;
  padding: 0.25rem 0.75rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.82rem;
  color: #323232;

  button {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #888;
    font-size: 0.9rem;
    line-height: 1;
    transition: color 0.2s;

    &:hover {
      color: #ff2e3e;
    }
  }
`;

export const DropdownButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid #e2e2e2;
  border-radius: 0.5rem;
  padding: 0.35rem 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.85rem;
  background: #fff;
  cursor: pointer;
  color: #323232;
  transition: border-color 0.2s;
  white-space: nowrap;

  &:hover {
    border-color: #ff9800;
  }
`;

export const DropdownWrapper = styled.div`
  position: relative;
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 100;
  min-width: 200px;
  overflow: hidden;
`;

export const DropdownOption = styled.button`
  width: 100%;
  text-align: left;
  padding: 0.6rem 1rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.85rem;
  background: #fff;
  border: none;
  cursor: pointer;
  color: #323232;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 152, 0, 0.08);
  }
`;

export const AddArenaButton = styled.button`
  width: 100%;
  border: 1.5px dashed #1e88e5;
  border-radius: 0.6rem;
  background: #fff;
  padding: 0.8rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.95rem;
  color: #1e88e5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin-top: 0.5rem;
  transition:
    background 0.2s,
    border-color 0.2s;

  &:hover {
    background: rgba(30, 136, 229, 0.04);
    border-color: #1565c0;
    color: #1565c0;
  }
`;

export const PlainInput = styled.input`
  width: 100%;
  height: 2.8rem;
  border: 0.5px solid #e2e2e2;
  border-radius: 0.56rem;
  padding: 0 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 1rem;
  color: #323232;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #ff9800;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const ModalidadeContainer = styled.div`
  min-width: 180px;
`;

export const FormButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-top: 1.5rem;

  .secondary-button,
  .primary-button {
    height: 2.8rem;
    border-radius: 0.55rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: 0.9rem;
    padding: 0 1.6rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .secondary-button {
    border: 1px solid #e2e2e2;

    &:hover {
      border: 1px solid #4caf50;
      svg {
        transition: transform 0.3s;
        stroke: #4caf50;
      }
    }
  }
`;
